import { render, staticRenderFns } from "./icon-like-button.vue?vue&type=template&id=327179fa&scoped=true&"
import script from "./icon-like-button.vue?vue&type=script&lang=js&"
export * from "./icon-like-button.vue?vue&type=script&lang=js&"
import style0 from "./icon-like-button.vue?vue&type=style&index=0&id=327179fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327179fa",
  null
  
)

export default component.exports